import { isMatch } from 'matcher';

const getConfig = (hopsConfig) => {
  let {
    name,
    datadog: {
      hostToStage,
      applicationId,
      clientToken,
      service,
      version,
      costCenter,
      sessionSampleRate,
    } = {},
  } = hopsConfig;

  service = service ? service : name;
  const hostname = global?.document?.location?.hostname;

  hostToStage = hostToStage || {
    'preview.xing.com': 'preview',
    'preview*.xing.com': 'preview',
    '*preview.xing.com': 'preview',
    '*.kenv.xing.com': null, // datadog is not allowed on xingboxes
    '*.env.xing.com': null,
    localhost: null,
    '*': 'production',
  };

  const [, stage] =
    Object.entries(hostToStage).find(([host]) => isMatch(hostname, host)) || [];

  const enabled =
    Boolean(stage) &&
    Boolean(applicationId) &&
    Boolean(clientToken) &&
    Boolean(service) &&
    Boolean(costCenter);

  return {
    enabled,
    sessionSampleRate,
    stage,
    applicationId,
    clientToken,
    service,
    version,
    costCenter,
  };
};

export { getConfig };
